$('.Header-openNavBtn').click(function toggleNavButton() {
  $('.Header-navbar, .Header-navbarMenu').toggleClass('is-active');
  $('.icon i', this).toggleClass('fa-bars fa-close');
});

$(document).ready(() => {
  // Capture referrals
  const urlParams = new URLSearchParams(location.search);
  const referralParam = urlParams.get('r');

  if (referralParam) {
    const domain = location.hostname.substr(location.hostname.indexOf('.') + 1);

    document.cookie = `r=${urlParams.get('r')};domain=${domain}; path=/;secure`;

    if (urlParams.get('rd')) {
      document.cookie = `rd=${urlParams.get('rd')};domain=${domain}; path=/;secure`;
    }

    // Set finder reg page
    if (referralParam === 'uyG9Swrum8MXr1Bx') {
      $('body').addClass('has-finder-referral');
    }
  }
  $('form[data-recaptcha-form!=true]').submit(() => {
    // for forms without recaptcha
    $(this).find('button[type=submit]').prop('disabled', true);
  });

  $(document).on('click', '.notification > button.delete', () => {
    $(this).parent().addClass('is-hidden');
  });

  $('form').first()
    .find('input[type="text"]')
    .first()
    .focus();

  $('.disclaimer-toggle').on('click', () => {
    $('.full-disclaimer').toggleClass('is-hidden');
  });
});
